/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(filingId) {
  var deferred = $.Deferred();
  $.soap({
    body: {
      GetCreditUnionParityFiling: {
        $xmlns: 'http://dobs.pa.gov/dp/filing/bpm/1.0',
        FilingID: filingId
      }
    },
    blueprintArrays: [
      'GetCreditUnionParityFilingResponse.SupportingDocuments.DP_FilingSupportingDocument',
      'GetCreditUnionParityFilingResponse.ParityAgencyInterpretiveDocuments.DP_FilCUParityAgencyInterpretiveDocument'
    ],
    blueprint: {
      id: '$..ID',
      filingId: '$..FilingID',
      activityTypeId: '$..ActivityTypeID',
      proposedActivity: '$..ProposedActivity',
      isCitationUSC: '$..IsCitationUSC',
      citationUSCComments: '$..CitationUSCComments',
      isCitationCFR: '$..IsCitationCFR',
      citationCFRComments: '$..CitationCFRComments',
      isCitationOther: '$..IsCitationOther',
      citationOtherComments: '$..CitationOtherComments',
      isCitationInterpretiveLetter: '$..IsCitationInterpretiveLetter',
      citationInterpretiveLetterComments: '$..CitationInterpretiveLetterComments',
      citationBasisForBankingInstitution: '$..CitationBasisForBankingInstitution',
      contactInformationComments: '$..ContactInformationComments',
      riskAnalysisDocument: {
        fileId: '$..RiskAnalysisDocID',
        fileName: '$..RiskAnalysisDocName'
      },
      contactInformationDocument: {
        fileId: '$..ContactInformationDocID',
        fileName: '$..ContactInformationDocName'
      },
      imposedRestrictionsDocument: {
        fileId: '$..ImposedRestrictionsDocID',
        fileName: '$..ImposedRestrictionsDocName'
      },
      supportingDocuments: [
        '$..DP_FilingSupportingDocument',
        {
          id: '$..ID',
          filingId: '$..FilingID',
          documentId: '$..DocumentID',
          documentName: '$..DocumentName',
          documentTypeId: '$..DocumentTypeID',
          documentType: '$..DocumentType',
          file: {
            fileId: '$..DocumentID',
            fileName: '$..DocumentName'
          }
        }
      ],
      parityAgencyInterpretiveDocuments: [
        '$..DP_FilCUParityAgencyInterpretiveDocument',
        {
          id: '$..ID',
          filingId: '$..CUParityFilingID',
          documentId: '$..DocumentID',
          documentName: '$..DocumentName',
          documentTypeId: '$..DocumentTypeID',
          documentType: '$..DocumentType',
          file: {
            fileId: '$..DocumentID',
            fileName: '$..DocumentName'
          }
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      response.isCitationUSC = response.isCitationUSC === '1';
      response.isCitationCFR = response.isCitationCFR === '1';
      response.isCitationOther = response.isCitationOther === '1';
      response.isCitationInterpretiveLetter = response.isCitationInterpretiveLetter === '1';
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
